import type { Dispatch } from 'redux';
import type { CampaignState, CampaignAction } from '@/redux/campaign/types';

export enum Actions {
  SetCampaignData = 'SetCampaignData',
  SetCampaignDataFail = 'SetCampaignDataFail',

  SetCampaignGameIndex = 'SetCampaignGameIndex',
  SetCampaignGameIndexFail = 'SetCampaignGameIndexFail',

  SetCampaignServerTime = 'SetCampaignServerTime',
  SetCampaignServerTimeFail = 'SetCampaignServerTimeFail',

  SetCampaignCurrentTime = 'SetCampaignCurrentTime',
  SetCampaignCurrentTimeFail = 'SetCampaignCurrentTimeFail'
}

export const setCampaignData =
  (data: CampaignState) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      dispatch({ type: Actions.SetCampaignData, data });
    } catch (error) {
      dispatch({ type: Actions.SetCampaignDataFail, error });
    }
  };

export const setCampaignGameIndex =
  (index: number) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      dispatch({ type: Actions.SetCampaignGameIndex, index });
    } catch (error) {
      dispatch({ type: Actions.SetCampaignGameIndexFail, error });
    }
  };

export const setCampaignServerTime =
  (time?: string) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      time && dispatch({ type: Actions.SetCampaignServerTime, time });
    } catch (error) {
      dispatch({ type: Actions.SetCampaignServerTimeFail, error });
    }
  };

export const setCampaignCurrentTime =
  (time?: string) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      dispatch({ type: Actions.SetCampaignCurrentTime, time });
    } catch (error) {
      dispatch({ type: Actions.SetCampaignCurrentTimeFail, error });
    }
  };
